if (!customElements.get('section-press')) {
  class SectionPress extends HTMLElement {
    constructor() {
      super();

      let section = (this.section = this.dataset.section);
      this.selectors = {
        logosSlider: `.js-logos-slider-${section}`,
        articlesSlider: `.js-articles-slider-${section}`
      }
  
      this.data = {
        autoplay: 'autoplay',
        autoplaySpeed: 'autoplaySpeed'
      }
  
      this.settings = {
        autoplay: this.dataset[this.data.autoplay] == 'true',
        autoplaySpeed: parseInt(this.dataset[this.data.autoplaySpeed] || 5000)
      }
  
      if (
        !this.querySelector(this.selectors.logosSlider) ||
        !this.querySelector(this.selectors.articlesSlider)
      ) return;
  
      this.init();
      
    }
  
    init() {
      this.setupArticlesSlider();
      this.setupLogosSlider();
      this.initSliders();
    }
  
    setupLogosSlider() {     
      let settings = {
        init: false,
        loop: true,
        speed: 600,
        autoHeight: false,
        preventInteractionOnTransition: true,
        slidesPerView: 2,
        centeredSlides: true,
        loopAdditionalSlides: 2,
        slideToClickedSlide: true,
        on: {
          slideChangeTransitionEnd: (logosSlider) => {
            logosSlider.loopFix();
          }
        },
        thumbs: {
          swiper: this.articlesSlider
        },
        breakpoints: {
          990: {
            slidesPerView: 4
          },
          750: {
            slidesPerView: 3
          }
        }
      };

      if (this.settings.autoplay) {
        Object.assign(settings, {
          autoplay: {
            delay: this.settings.autoplaySpeed
          }
        });
      };
      
      this.logosSlider = new Swiper(this.selectors.logosSlider, settings);
      
    }
  
    setupArticlesSlider() { 
      let settings = {
        init: false,
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        speed: 600,
        slidesPerView: 1,
        allowTouchMove: false
      };
      
      this.articlesSlider = new Swiper(this.selectors.articlesSlider, settings);
      
    }
  
    initSliders() {
      this.articlesSlider.init();
      this.logosSlider.init();      
      
    }
    
  }

  customElements.define('section-press', SectionPress);
}